// JavaScript Document
//components/signs/sign.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
//import ButtonBase from '@material-ui/core/ButtonBase';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
//import Map from './Map';
import SaveIcon from '@material-ui/icons/Save';
import Basic from './forms/Basic';
import Location from './forms/Location';
import Options from './forms/Options';
import SignData from './forms/Data';
import AutoUpdate from './forms/AutoUpdate';
import Advanced from './forms/Advanced';
import AmberAlert from './forms/AmberAlert';
import ITSSize from './forms/Size';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
	//backgroundColor: theme.palette.background.paper
  },
  paper: {
    padding: theme.spacing(2),
    margin: 'auto'
  },
  signType : {
	 // backgroundImage:'url(uploaded/file_17_vcalmVMS.png)', //'url('+sign.sign_type_obj.path+')', 
	  backgroundSize:'contain', 
	  backgroundRepeat:'no-repeat', 
	  backgroundPosition:'center',	
	  textAlign:'center',
	 // direction:'row',
	 // alignItems:'flex-end'
	  //verticalAlign:'bottom',
	  //textAlign:'center',
	  //display:'table-cell',
	  //flexGrow: 1,
	  //display: 'table-cell'
  },
	advancedCard : {
		margin: theme.spacing(1),
		display: "flex",
		flexDirection:"column",
		alignItems:"stretch",
		justifyContent:"center",
		flexWrap:"wrap"
	},
	advancedContent : {
		display: "flex",
		flexGrow: 1,
		alignItems: "center",
		justifyContent: "space-around",
		flexWrap: "wrap"
	},
  signTypeText : {
	  alignSelf: 'flex-end'
  },
  center: {
	textAlign: 'center'
  },
  image: {
    width: 128,
    height: 128,
  },
  break: {
	  height:20
  },
  img: {
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
  },
}));




export default function SignDetails(props) {
	const classes = useStyles();
	const {handleSend, user, sign, onChange, save} = props;
	//const [geoloc, setGeoloc] = React.useState('-117.8027955, 33.86.25262');
	//const [address, setAddress] = React.useState('');
	const [signId, setSignId] = React.useState(0);
	const [changed, setChanged] = React.useState(false);
	const [saveLabel, setSaveLabel] = React.useState('Save');
	const [mySign, setMySign] = React.useState({
		sign_type_obj:{},
		options:[],
		geo_location: '-117.8027955, 33.86.25262',
	});
	React.useEffect(() => {
		if(sign && sign.id !== signId){
			setSignId(sign.id);
			setMySign(sign);
			//if(sign.geo_location){
			//	setGeoloc(sign.geo_location);
			//}
			//if(sign.address){
			//	setAddress(sign.address);
			//}
		}
	   // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [sign]);
	/*
	React.useEffect(() => {
		handleUpdateValues({
			geo_location: geoloc,
			address: address
		});
	}, [geoloc, address]);
	*/
	/*
	const handleUpdateValues = (newvals) => {
		//only update if current data is present
		var newSign = Object.assign(mySign, newvals);
		if(newSign.id){
			setMySign(newSign);
			//if(onChange)
			//	onChange(newSign);
			//setChanged(true);
			//setForce(false);
		} else {
			console.log('did not update');
		}
	}
	*/
	const handleUpdateDetails = (newvals) => {
		
		var newSign = Object.assign({}, mySign, newvals);
		//console.log('old', mySign, 'new', newSign);
		if(newSign.id){
			setMySign(newSign);
			setChanged(true);
			if(onChange){
				onChange(newSign);
				console.log("something changed!");
			}
		}
	}
	const handleUpdateOptions = (opts) => {
		console.log(opts);
		handleUpdateDetails({options: opts});
	}
	/*
	const handleDragPointer = (geoloc, address) =>{
		console.log(geoloc);
		console.log(address);
		setGeoloc(geoloc);
		setAddress(address);
	}
	*/
	
	//Handle save buttonclick
	const handleSave = (e) => {
		setSaveLabel('Saving');
		//console.log("Save button clicked!");
		const payload = {
			vso: 'sign',
			sign : mySign,
			subaction : 'save'
		};
		//console.log('payload', payload);
		handleSend(payload, (data) => {
			console.log(data);
			setChanged(false);
			setSaveLabel('Save');
			setMySign(data.sign);

		});
	}
	const saveButton = () => {
		if(changed && !save){
			return (
				<Button 
					variant="contained" 
					color="primary" 
					onClick={handleSave} 
					endIcon={<SaveIcon />}
					disabled={saveLabel==='Saving' ? true : false}
				>
					{saveLabel}
				</Button>
			);
		}
		return '';
	}
	const renderAutoUpdate = () => {
		if(mySign.ip)
			return (
				<Grid item sm={12} md={6} xl={4}>
					<AutoUpdate sign={mySign} user={user} handleSend={handleSend} onChange={handleUpdateDetails} />
				</Grid>
			);
		return '';
	}
	const renderAmberAlert = () => {
		if(mySign.ip){
			if(mySign.sign_type_obj){
				if(mySign.sign_type_obj.class_code === 'Ph4')
					return (
						<Grid item sm={12} md={6} xl={4}>
							<AmberAlert sign={mySign} user={user} handleSend={handleSend} onChange={handleUpdateDetails} />
						</Grid>
					);
				if(mySign.sign_type_obj.class_code === 'Ph5')
					return (
						<Grid item sm={12} md={6} xl={4}>
							<Typography>PH5 ICM</Typography>
						</Grid>
					);
			}
		}
		return '';
	}
	const renderAdvanced = () => {
		if(mySign.sign_type_obj){
			if(mySign.sign_type_obj.class_code === 'Ph5')
				return (
					<Grid item sm={12} md={6} xl={4}>
						<ITSSize sign={mySign} user={user} handleSend={handleSend} onChange={handleUpdateDetails} />
					</Grid>
				);
		}
		return (
			<Grid item sm={12} md={6} xl={4}>
				<Advanced sign={mySign} user={user} handleSend={handleSend} onChange={handleUpdateDetails} />
			</Grid>
		);
	}
	const renderRibbon = () => {
		if(onChange)
			return '';
		return (
			<AppBar position="static" style={{backgroundColor: '#CCC'}}>
				<Box display="flex">
					{saveButton()}
				</Box>
			</AppBar>
		);
	}
	return (
		<div className={classes.root}>
			{renderRibbon()}
			<Box p={2}>
				<Grid container spacing={2}>
					<Grid item sm={12} md={6} xl={4}>
						<Basic sign={mySign} user={user} handleSend={handleSend} onChange={handleUpdateDetails} />
					</Grid>
					<Grid item sm={12} md={6} xl={4}>
						<Location sign={mySign} user={user} handleSend={handleSend} onChange={handleUpdateDetails} />
					</Grid>
					<Grid item sm={12} md={6} xl={4}>
						<Options sign={mySign} user={user} handleSend={handleSend} onChange={handleUpdateOptions} />
					</Grid>
					<Grid item sm={12} md={6} xl={4}>
						<SignData sign={mySign} user={user} handleSend={handleSend} onChange={handleUpdateDetails} />
					</Grid>
					{renderAutoUpdate()}
					{renderAdvanced()}
					{renderAmberAlert()}
				</Grid>
			</Box>
		</div>
	);
}
